import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { serverUrl } from "../nestserver";

function authConfig(params) {
  const config = {
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      "Access-Control-Allow-Origin": "*",
    },
  };
  if (params) config.params = params;
  return config;
}

/* -------------------------------------------------------------------------- */
/*                        Get Instructor Devices (Admin)                      */
/* -------------------------------------------------------------------------- */

export function useGetInstructorDevices(queryOptions = {}, params = {}) {
  async function getInstructorDevices() {
    const res = await axios.get(
      `${serverUrl}/instructor-device`,
      authConfig(params),
    );
    return res.data;
  }

  return useQuery(["instructorDevices", params], getInstructorDevices, {
    enabled: true,
    ...queryOptions,
  });
}

/* -------------------------------------------------------------------------- */
/*                    Approve / Reject a Device (Admin)                       */
/* -------------------------------------------------------------------------- */

export function useUpdateDeviceStatus(mutationOptions) {
  function updateDeviceStatus({ deviceId, data }) {
    return axios.put(`${serverUrl}/instructor-device/status/${deviceId}`, data, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });
  }

  return useMutation(updateDeviceStatus, mutationOptions);
}

/* -------------------------------------------------------------------------- */
/*                       Device Audit Trail (Admin)                           */
/* -------------------------------------------------------------------------- */

export function useGetDeviceAudit(queryOptions = {}, params = {}) {
  async function getDeviceAudit() {
    const res = await axios.get(
      `${serverUrl}/instructor-device/audit`,
      authConfig(params),
    );
    return res.data;
  }

  return useQuery(["instructorDeviceAudit", params], getDeviceAudit, {
    enabled: true,
    ...queryOptions,
  });
}
